export { AscLockPageLayout } from './AscLockPageLayout';
